import { ReactNode, FunctionComponent } from 'react';
import { css } from '@emotion/css';

import colors from '@/theme/colors';

type Props = {
  children: ReactNode;
};

const classNames = {
  heading: css`
    width: 100%;
    max-width: 420px;
    font-family: Proxima Nova, Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: bold;
    line-height: 28px;
    color: ${colors.prussian};
    padding-top: 8px;
  `,
};

export const PrimaryHeading: FunctionComponent<Props> = ({ children }) => (
  <h1 className={classNames.heading}>{children}</h1>
);
